import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data63 from '../../data/data63.json'
import ArticleList from '../../Components/ArticleList';

const AnnualReports: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>年度报告</h1>
                <ArticleList dataId="63" data={data63 as any} />
            </div>
        } />
    );
};

export default AnnualReports;